import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type {
  MediaLinksVm,
  MediaLinksListItem,
  MediaLinksListResponse,
} from '@/api/types/empMediaLinks.types'

export class EmpMediaLinksService {
  async getAll(
    branchId: number,
    empId: number,
    pageNumber: number,
    pageSize: number
  ): Promise<MediaLinksListResponse> {
    const url = endpoints.empMediaLinks.getAll(branchId, empId, pageNumber, pageSize)
    const res = await apiClient.get<MediaLinksListResponse | MediaLinksListItem[] | { data: MediaLinksListItem[] }>(url)
    const raw = res.data as any
    if (raw && Array.isArray(raw.data)) {
      return {
        data: raw.data,
        totalRecords: raw.totalRecords ?? raw.data.length ?? 0,
        pageNumber: raw.pageNumber ?? pageNumber,
        pageSize: raw.pageSize ?? pageSize,
      }
    }
    if (Array.isArray(raw)) {
      return {
        data: raw as MediaLinksListItem[],
        totalRecords: (raw as MediaLinksListItem[]).length,
        pageNumber,
        pageSize,
      }
    }
    return { data: [], totalRecords: 0, pageNumber, pageSize }
  }

  async getById(id: number): Promise<MediaLinksVm> {
    const url = endpoints.empMediaLinks.getById(id)
    const res = await apiClient.get<MediaLinksVm | { data: MediaLinksVm }>(url)
    const raw = res.data as any
    if (raw && typeof raw === 'object' && 'data' in raw) return raw.data as MediaLinksVm
    return raw as MediaLinksVm
  }

  async getByEmployeeId(employeeId: number): Promise<MediaLinksListItem[]> {
    const url = endpoints.empMediaLinks.getByEmployeeId(employeeId)
    const res = await apiClient.get<MediaLinksListItem[] | { data: MediaLinksListItem[] }>(url)
    const raw = res.data as any
    if (Array.isArray(raw)) return raw as MediaLinksListItem[]
    if (raw && typeof raw === 'object' && 'data' in raw && Array.isArray(raw.data)) {
      return raw.data as MediaLinksListItem[]
    }
    return []
  }

  async save(payload: MediaLinksVm): Promise<unknown> {
    const url = endpoints.empMediaLinks.save
    console.log('[MediaLinks] SAVE payload:', { url, payload })
    const res = await apiClient.post(url, payload)
    console.log('[MediaLinks] SAVE response:', res.data)
    return res.data
  }

  async update(payload: MediaLinksVm): Promise<unknown> {
    const url = endpoints.empMediaLinks.update
    console.log('[MediaLinks] UPDATE payload:', { url, payload })
    const res = await apiClient.put(url, payload)
    console.log('[MediaLinks] UPDATE response:', res.data)
    return res.data
  }

  async delete(id: number): Promise<void> {
    const url = endpoints.empMediaLinks.delete(id)
    await apiClient.delete(url)
  }
}

export const empMediaLinksService = new EmpMediaLinksService()
